module.exports = __webpack_public_path__ + "img/image-013.ee3de437.png";